import React, { useEffect, useState } from "react";
import { Paper, Toolbar, Typography } from "@mui/material";
import MUIDataTable from "mui-datatables";
import AppConstants from '../../Constants/Constants.js';

function Datatable(props) {
  const [user, setUser] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let token =localStorage.getItem('token')
    if(token) {
      const getData = async () => {
        const url = `${AppConstants.backendURL}/user-management/regular-users`
        try {
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log(response, "forresponse");
          if (response.statusText === 'OK') {
            const data = await response.json();
            console.log(data, "For data");
            setUser(data);
          } else {
            throw new Error('Request failed')
          }
        } catch (error) {
          console.log(error);
        }
      };
      getData();

    }

  }, []);

  const options = {
    elevation: 0,
    filterType: "multiselect",
    selectableRows: "none",
    selectableRowsHeader: false,
    download: false,
    print: false,
    searchPlaceholder: "Enter search key",
    searchAlwaysOpen: true
  };
  const columns = [
    {
      name: "serial_no",
      label: "S. No",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1,
      },
    },
    {
      name: "name",
      label: "name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "email",
      label: "email",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "trial_days_left",
      label: "trial days",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value > 0 ? `${value} days` : `0 days`,
      },
    },
    {
      name: "active",
      label: "active",
      options: {
        filter: true,
        sort: false,
      },
    },

    {
      name: "created_at",
      label: "created_at",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "updated_at",
      label: "updated_at",
      options: {
        filter: true,
        sort: false,
      },
    },

    {
      name: "status",
      label: "status",
      options: {
        filter: true,
        sort: false,
      },
    }
  ];
  return (
    <>
      <Paper
        elevation={3}
        sx={{
          width: "80%",
          float: "right",
          marginRight: "20px",
          marginTop: "80px",
        }}
      >
        <Toolbar
          mt={3}
          sx={{
            padding: "1.2rem",
            borderBottom: "4px solid var(--primary-color)",
          }}
        >
          <Typography
            sx={{
              flex: "1 1 100%",
              color: "var(--primary-color)",
              fontWeight: "bold",
            }}
            variant="h5"
            id="tableTitle"
          >
            Free Users
          </Typography>

        </Toolbar>
        <MUIDataTable
          className="m-3"
          data={user}
          columns={columns}
          options={options}
        />
      </Paper>
    </>
  );
}

export default Datatable;

